import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@origo/origo-ui';
import type { DocumentItem } from '../../../types';
import styles from './UnlinkDocumentDialog.module.css';

interface UnlinkDocumentDialogProps {
    pendingUnlink: DocumentItem | null;
    onConfirm: () => void;
    onCancel: () => void;
    isUnlinking?: boolean;
}

/** Bekreft at et dokument fjernes fra behandlingen. Dokumentet slettes ikke,
 *  det blir liggende på planen (jf. AK 3.2.1). */
const UnlinkDocumentDialog: React.FC<UnlinkDocumentDialogProps> = ({
    pendingUnlink,
    onConfirm,
    onCancel,
    isUnlinking,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={pendingUnlink !== null}
            onClose={onCancel}
            title={t('processings.documents.unlink.title')}
            footer={
                <div className={styles.dialogFooter}>
                    <Button variant="secondary" onClick={onCancel} disabled={isUnlinking}>
                        {t('common.cancel')}
                    </Button>
                    <Button variant="primary" onClick={onConfirm} disabled={isUnlinking}>
                        {t('processings.documents.unlink.confirm')}
                    </Button>
                </div>
            }
        >
            <p>{t('processings.documents.unlink.body', { navn: pendingUnlink?.dokumentnavn ?? '' })}</p>
        </Dialog>
    );
};

export default UnlinkDocumentDialog;
